module.exports = __webpack_public_path__ + "static/media/README.9febfa26.md";